import * as React from 'react';
import Field from '../Field/Field';
import { Button } from '../../index';
import { Form } from 'react-final-form';
import { useTheme } from '../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../context';
import { getCheckInUrl } from '../../utils';
import { useRetrieveBookingValidation } from '../../RetrieveBooking/hooks';
const Checkin = props => {
    const theme = useTheme('Forms').Booking;
    const { t } = useTranslation('Forms');
    const { Engine: { checkInURL }, global: { reserveEngines } } = useConfig();
    const { ticketNumberValidation, lastNameValidation, requiredValidationWrapper } = useRetrieveBookingValidation();
    const onSubmit = (values) => {
        const ticket = values['ticket'];
        const lastName = values['lastName'];
        window.open(getCheckInUrl(checkInURL, '', ticket, lastName, reserveEngines));
    };
    return (React.createElement(Form, { onSubmit: onSubmit, validateOnBlur: true, initialValues: {
            ticket: '',
            lastName: ''
        } }, ({ handleSubmit }) => (React.createElement("div", { className: theme.container },
        React.createElement("form", { onSubmit: handleSubmit, className: theme.inner },
            React.createElement(Field, { name: "ticket", label: t('Ticket number'), validation: requiredValidationWrapper(ticketNumberValidation) }),
            React.createElement(Field, { name: "lastName", label: t('Last name'), validation: requiredValidationWrapper(lastNameValidation) }),
            React.createElement(Button, { type: "submit", variant: "flat", size: "large", className: theme.submit }, t('Continue')))))));
};
export default Checkin;
